/**
 * Qual cliente é o escopo de UMA conversa.
 *
 * ★ Existe porque `clienteEscopo` é um valor só no store, e não um por
 * conversa: quem escolhia um cliente via o escopo GRUDAR — atravessava troca de
 * conversa e conversa nova, e o cartão "Cliente em foco" aparecia sobre uma
 * conversa que, no banco, não tem cliente nenhum.
 *
 * O dado para desfazer isso já vinha do backend e ninguém usava: a listagem
 * devolve `id_cliente_app`, `nome_cliente` e `codigo_cliente` em CADA linha
 * (`resource_conversations`: "id_cliente_app sai SEMPRE"). É o mesmo caminho
 * que `selecionarConversa` já percorre para restaurar o MODELO da conversa.
 */

/**
 * ★ Prefere o objeto do CATÁLOGO de clientes ao devolvido pela conversa.
 *
 * Os dois têm `id` e nome, mas só o do catálogo é o mesmo objeto que o seletor
 * de escopo entrega — e o cartão e o chip leem campos dele (`name`/`nome`,
 * `#id`). Montar um objeto mínimo aqui faria a MESMA conversa ser exibida de
 * um jeito ao ser reaberta e de outro ao ser escolhida na lista.
 *
 * O objeto mínimo é o fallback, não o caminho: a lista de clientes é carregada
 * de forma assíncrona, e sem ele quem abre uma conversa antes da carga perderia
 * o cartão em vez de vê-lo com menos detalhe.
 *
 * @param {Object} conversa linha da listagem de conversas
 * @param {Array<Object>} clientes catálogo já carregado (`user/allClients`)
 * @returns {Object|null} cliente do escopo, ou `null` para conversa geral
 */
export const clienteDaConversa = (conversa, clientes) => {
  const id = conversa && conversa.id_cliente_app
  if (!id) return null

  const doCatalogo = (clientes || []).find(
    (cliente) => cliente && Number(cliente.id) === Number(id)
  )
  if (doCatalogo) return doCatalogo

  // Sem o catálogo: o mínimo que o cartão e o chip sabem exibir.
  return { id, name: conversa.nome_cliente || conversa.codigo_cliente || '' }
}
